import { Affix, Anchor, Badge, Button, Card, Col, Empty, message, Radio, RadioChangeEvent, Row, Select, Space, Spin, Tag } from "antd";
import {
    LeftOutlined,
    RightOutlined
} from '@ant-design/icons';
import Search from 'antd/es/input/Search';
import React, { useEffect, useState } from 'react';
import { Tree, TreeNode } from "react-organizational-chart";
import jsonData from "../rule.json";
import './styles.css'; // 引入自定义样式文件

type RemoteLifeCycleStatus = {
    platform_site_key: string;
    status: number;
    predict_delisting_time: string;
    suspend_order_deadline: string;
}

type RemoteLifeCycleStatusColl = Record<string, RemoteLifeCycleStatus>

interface Rule {
    platformSiteList: string[];
    matchingType: string;
    matchingStatusList: number[];
}
interface DataItem {
    platformSiteList: string[];
    followBigPlatformSite: Partial<Record<string, Rule>>;
}
interface SinglePlatformRuleItem {
    platformSite: string;
    followBigPlatformSite: Partial<Record<string, Rule>>;
}

const isDev = process.env.NODE_ENV === 'development'



const statusMapping: { [key: string]: string } = {
    "0": "初始",
    "1": "卖完不做",
    "10": "不可售",
    "20": "只售卖",
    "30": "暂停下单",
    "20009": "已结束",
};
// const colorMap: {[key:string]: string} = { 
//     '初始': '56, 124, 49', 
//     '卖完不做': '217, 47, 35',
//     '暂停下单': '250, 221, 75',
//     '只售卖': '0, 0, 0',
//     '不可售': '0, 0, 0',
//     '已结束': '124, 128, 131',

// };
const colorMap: { [key: string]: string } = {
    '初始': '50, 180, 80', // 深绿色
    '卖完不做': '220, 50, 50', // 深红色
    '已结束': '120, 120, 120', // 深灰色
    '暂停下单': '255, 200, 50', // 深黄色
};

const colorHexMap: { [key: string]: string } = {
    '初始': '#32B450',      // 深绿色
    '卖完不做': '#e85c5cff',  // 深红色
    '已结束': '#787878',    // 深灰色
    '暂停下单': '#FFC832',  // 深黄色
};

const symbolMapping: { [key: string]: string } = {
    "all": "全部",
    "any": "任一",
    "allSoldOut": "全部是卖完不做或已结束"
};

interface StatusDisplayProps {
    platformSite: string;
    remoteLifeCycleStatus: RemoteLifeCycleStatusColl | null;
}

const StatusDisplay: React.FC<StatusDisplayProps> = ({
    platformSite, remoteLifeCycleStatus
}) => {
    const obj = remoteLifeCycleStatus?.[platformSite];
    const statusKey = obj?.status?.toString();
    const statusText = statusKey ? statusMapping[statusKey] ?? '' : '';


    return (
        // <span className="text-[11px]" style={{ color: `rgb(${colorMap[statusText] ?? '0,0,0'})` }}>
        //     {statusText}
        //     {obj?.predict_delisting_time && `(${obj?.predict_delisting_time})`}
        //     {obj?.suspend_order_deadline && `(${obj?.suspend_order_deadline})`}
        // </span>
        <span>
            {obj ?
                (<Tag color={colorHexMap[statusText]} style={{ fontSize: '12px' }}>
                    {statusText}
                    {/* {obj?.predict_delisting_time && `:${obj?.predict_delisting_time}`} */}
                    {/* {obj?.suspend_order_deadline && `:${obj?.suspend_order_deadline}`} */}
                </Tag>)
                : ''}
        </span>
    );
};

interface PlatformSiteSelectProps {
    placeholder: string;
    options: string[];
    value: string | null;
    onChange: (value: string) => void
}
const SelectComponent: React.FC<PlatformSiteSelectProps> = (
    { placeholder, options, value, onChange }
) => (
    <Select
        value={value}
        showSearch
        allowClear
        placeholder={placeholder}
        filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
        onChange={(value: string) => onChange(value)}
        options={options.map(options => ({ value: options, label: options }))}
        style={{ width: '150px' }} />
)

let platform2SiteMap: Record<string, string[]> = {}
let site2PlatformMap: Record<string, string[]> = {}
let allPlatform: string[] = []
let allSite: string[] = []
let data: DataItem[] = []

const switchDataSource = (mode: string) => {
    console.info('切换数据源了' + mode)
    if (mode === 'always') {
        data = jsonData["alwaysFollow"]
    } else if (mode === 'effect') {
        data = jsonData["skuEffectFollow"]
    } else {
        data = []
    }
    platform2SiteMap = {}
    site2PlatformMap = {}
    data.map(s => s.platformSiteList).flat().forEach(s => {
        const [platform, site] = s.split(':')

        if (!platform2SiteMap[platform]) {
            platform2SiteMap[platform] = []
        }
        platform2SiteMap[platform].push(site)

        if (!site2PlatformMap[site]) {
            site2PlatformMap[site] = []
        }
        site2PlatformMap[site].push(platform)
    })
    allPlatform = [...Object.keys(platform2SiteMap).sort()]
    allSite = [...Object.keys(site2PlatformMap).sort()]

}

switchDataSource('always')

const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
};

const PlatformTreeView = () => {
    console.info('do PlatformTreeView')
    const [skuCode, setSkuCode] = useState<string>('');
    const [remoteData, setRemoteData] = useState<RemoteLifeCycleStatusColl>({});
    const [selectPlatform, setSelectPlatform] = useState<string | null>(null);
    const [selectSite, setSelectSite] = useState<string | null>(null);
    const [mode, setMode] = useState<string>('always');

    const [selectPlatformOpt, setSelectPlatformOpt] = useState<string[]>(allPlatform);
    const [selectSiteOpt, setSelectSiteOpt] = useState<string[]>(allSite);

    const [messageApi, contextHolder] = message.useMessage();
    const [loading, setLoading] = useState(false);

    const doSearch = () => {
        console.info('ready search api:' + skuCode)
        if (skuCode) {
            setLoading(true)
            fetchData(skuCode).then((res) => {
                setRemoteData(res);
                messageApi.success({ content: '查询成功~', style: {} }, 3)
            }).catch(error => {
                messageApi.error('请求失败，后端服务未启动', 2.5);
            }).finally(() => {
                setLoading(false)
            });
        } else {
            messageApi.error('请输入skuCode')
        }
    };

    const doReset = () => {
        setSelectPlatform(null)
        setSelectSite(null)
        setSkuCode('')
        setSelectSiteOpt(allSite)
        setSelectPlatformOpt(allPlatform)
        setRemoteData({})
    };

    const platformChange = (value: string) => {
        setSelectPlatform(value)
        if (value) {
            const optianalSite: string[] = platform2SiteMap[value];
            setSelectSiteOpt(optianalSite)
        } else {
            setSelectSiteOpt(allSite)
        }
        scrollToTop()
    }

    const siteChange = (value: string) => {
        setSelectSite(value)
        if (value) {
            const optianalPlatform: string[] = site2PlatformMap[value];
            setSelectPlatformOpt(optianalPlatform)
        } else {
            setSelectPlatformOpt(allPlatform)
        }
        scrollToTop()
    }


    const radioChange = ({ target: { value } }: RadioChangeEvent) => {
        setMode(value);
        switchDataSource(value)
        setSelectPlatformOpt(allPlatform)
        setSelectSiteOpt(allSite)
        setSelectPlatform(null)
        setSelectSite(null)
    }

    const searchForm = () => {
        console.info('do searchForm')
        return (
            <Affix offsetTop={0}>
                <Row justify="center" gutter={16} style={{ height: 100, backgroundColor: 'white' }} align="middle">
                    <Col>
                        <Radio.Group defaultValue="always" buttonStyle="solid" onChange={radioChange} value={mode}>
                            <Radio.Button value="always">始终跟随</Radio.Button>
                            <Radio.Button value="effect">生效跟随</Radio.Button>
                        </Radio.Group>
                    </Col>
                    <Col>
                        <SelectComponent value={selectPlatform} options={selectPlatformOpt} onChange={platformChange} placeholder='平台' />
                    </Col>
                    <Col>
                        <SelectComponent value={selectSite} options={selectSiteOpt} onChange={siteChange} placeholder='站点' />
                    </Col>
                    {
                        // 开发环境才能查询sku
                        isDev &&
                        <Col>
                            {contextHolder}
                            <Search placeholder="请输入SKU"
                                // allowClear
                                enterButton
                                loading={loading}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => { setSkuCode(e.target.value) }}
                                style={{ width: '300px' }}
                                value={skuCode}
                                onSearch={doSearch} />
                        </Col>
                    }
                    <Col>
                        <Button onClick={doReset}>重置</Button>
                    </Col>
                    <Col>
                        <Space>
                            规则总数:
                            <Badge
                                count={filterRuleList.length}
                                showZero
                                style={{ backgroundColor: '#52c41a', fontWeight: 'bold' }}
                            />
                            {/* <Tag bordered={false} color="#52c41a">{Object.keys(filterData).length}</Tag> */}
                        </Space>
                        {/* <span>规则总数: <span style={{ color: 'red', fontWeight: 'bold' }}>{Object.keys(filterData).length}</span></span> */}
                    </Col>
                </Row>
            </Affix>
        );
    };

    const filterFunc = () => {
        console.info('do filterFunc')
        const psFilter = (ps: string) => {
            const p = selectPlatform ? ps.includes(selectPlatform) : true
            const s = selectSite ? ps.includes(selectSite) : true
            return p && s;
        }

        const ruleList: SinglePlatformRuleItem[] = []
        data.forEach(e => {
            e.platformSiteList.forEach(ps => {
                if (psFilter(ps)) {
                    ruleList.push({ platformSite: ps, followBigPlatformSite: e.followBigPlatformSite })
                }
            })
        })
        return ruleList;
    }

    const filterRuleList = filterFunc()

    console.info(filterRuleList)

    return (
        <div style={{ backgroundColor: 'white', paddingBottom: '30px' }}>
            {searchForm()}
            <Row>
                <Col span={20}>
                    {/* {TreeList(filterRuleList, remoteData)} */}
                    <LazyLoadTree allTree={filterRuleList} remoteData={remoteData} />
                </Col>
                <Col span={4}>
                    <PSAnchor platformSite={filterRuleList.map(item => item.platformSite)} />
                </Col>
            </Row>
        </div>
    );
};


const PSAnchor = ({ platformSite }: { platformSite: string[] }) => {
    const [visible, setVisible] = useState(true);
    const width = 300

    return (
        <div>
            <Button
                shape="circle"
                icon={visible ? <RightOutlined /> : <LeftOutlined />}
                onClick={() => setVisible(!visible)}
                style={{
                    position: 'fixed',
                    top: '50%',
                    right: visible ? width - 15 : -8,
                    zIndex: 1001,
                }}
            />

            <div
                style={{
                    position: 'fixed',
                    width: width,
                    right: visible ? 0 : -width,
                    background: '#fff',
                    transition: 'right 0.2s',
                    height: '100vh',
                    borderLeft: '1px solid #f0f0f0',
                }}
            >
                <Anchor
                    offsetTop={100}
                    targetOffset={140}
                    style={{
                        // width: 300,
                        height: '100vh',
                        // background: "#fff",
                    }}
                    items={platformSite.map(ps => ({
                        key: ps,
                        href: '#' + ps,
                        title: ps,
                    }))} />
            </div>
        </div>
        //     {/* <Anchor
        // offsetTop={100}
        // targetOffset={140}
        // style={{
        //     // width: 300,
        //     height: '100vh',
        //     background: "#fff",
        // }}
        // items={platformSite.map(ps => ({
        //     key: ps,
        //     href: '#' + ps,
        //     title: ps,
        // }))} /> */}
    )

}
async function fetchData(skuCode: string) {
    try {
        const response = await fetch('http://127.0.0.1:5002/queryPlatformLifeCycle?skuCode=' + skuCode)
        if (!response.ok) throw new Error('请求失败');
        return await response.json();
    } catch (error) {
        console.error('请求生命周期api出错:', error);
        throw error; // 向上抛出错误
    }
}

const MemoTree = React.memo(({ ps, rules, index, remoteData }: { ps: string, rules: Partial<Record<string, Rule>>, index: number, remoteData: RemoteLifeCycleStatusColl | null }) => {
    return (
        <div id={ps}>
            <Tree
                key={`${ps}-${index}`}
                lineWidth='1px'
                lineColor='rgba(76, 167, 246, 1)'
                lineBorderRadius='10px'
                label={
                    <Card className="custom-card p-2 inline-block">
                        <strong>
                            <span className="mx-3"> {ps}</span>
                            <br />
                            <StatusDisplay platformSite={ps} remoteLifeCycleStatus={remoteData} />
                        </strong>
                    </Card>
                }
            >
                {Object.entries(rules).map(([status, rule]) => (
                    <TreeNode
                        key={`${ps}-${status}`}
                        label={
                            (
                                <Card className="custom-card p-2 bg-gray-100 inline-block">
                                    <strong>
                                        <span style={{ color: `rgb(${colorMap[statusMapping[status]] ?? '0,0,0'})` }}>{statusMapping[status] ?? status}</span></strong>
                                </Card>
                            )
                        }
                    >
                        <TreeNode
                            label={
                                <Card className="custom-card p-2 bg-gray-200 inline-block">
                                    {rule && `以下 ` + (rule.matchingStatusList.length > 0 ? `${symbolMapping[rule.matchingType]} 是 ${statusMapping[status] ?? status}` : symbolMapping[rule.matchingType])}
                                </Card>
                            }
                        >
                            {
                                <TreeNode
                                    key={`${ps}-${status}`}
                                    // style={{ whiteSpace: "pre-line" }}
                                    label={
                                        <Card className="custom-card p-2 bg-blue-100 inline-block" >
                                            {rule && rule?.platformSiteList?.length > 0 ?
                                                (
                                                    <div className="flex flex-col space-y-1 text-left">
                                                        {rule.platformSiteList.map(item => (

                                                            <Row>
                                                                <Col span={15}>
                                                                    {item}
                                                                </Col>
                                                                <Col span={9}>
                                                                    <StatusDisplay platformSite={ps} remoteLifeCycleStatus={remoteData} />
                                                                </Col>
                                                            </Row>

                                                            // <div key={item}>
                                                            //     <span className="mx-3" style={{ width: '60%' }}>{item}</span>
                                                            //     <StatusDisplay platformSite={ps} remoteLifeCycleStatus={remoteData} />
                                                            // </div>
                                                        ))}
                                                    </div>
                                                ) :
                                                (
                                                    '无规则'
                                                )}
                                        </Card>
                                    }
                                />
                            }
                        </TreeNode>
                    </TreeNode>
                ))}
            </Tree>
        </div>
    )
});


// function TreeList(ruleList: SinglePlatformRuleItem[], remoteData: RemoteLifeCycleStatusColl | null) {
//     console.info('do TreeList')

//     if (!!!ruleList.length) {
//         return (
//             <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
//             // <div className="flex flex-wrap justify-center mt-10 gap-6">
//             //     <span>无数据</span>
//             // </div>
//         )
//     }

//     return (
//         <div className="flex flex-wrap justify-center mt-10 gap-6">
//             {
//                 ruleList.map((item, index) => (
//                     <MemoTree ps={item.platformSite} rules={item.followBigPlatformSite} index={index} remoteData={remoteData}></MemoTree>
//                 ))
//             }

//         </div>
//     );
// }

const LazyLoadTree = ({ allTree, remoteData }: { allTree: SinglePlatformRuleItem[], remoteData: RemoteLifeCycleStatusColl | null }) => {

    console.info('all Tree:' + allTree.length)

    const [visibleTrees, setVisibleTrees] = useState<SinglePlatformRuleItem[]>([]);

    const total = allTree.length;

    useEffect(() => {
        let renderCnt = 0;
        const batchSize = 3; // 每批加载几棵树

        setVisibleTrees([])

        const loadNextBatch = () => {
            const nextBatch = allTree.slice(renderCnt, renderCnt + batchSize);
            if (nextBatch.length === 0) return;

            setVisibleTrees(prev => [...prev, ...nextBatch]);

            renderCnt += batchSize;

            if (renderCnt < total) {
                setTimeout(loadNextBatch, 200); // 每 200ms 加载一批
            }
        };

        // 初始加载
        loadNextBatch();
    }, [allTree]);


    if (!!!allTree.length) {
        return (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            // <div className="flex flex-wrap justify-center mt-10 gap-6">
            //     <span>无数据</span>
            // </div>
        )
    }

    return (

        <div className="flex flex-wrap justify-center mt-10 gap-6">
            {
                visibleTrees.map((item, index) => (
                    <MemoTree ps={item.platformSite} rules={item.followBigPlatformSite} index={index} remoteData={remoteData}></MemoTree>
                ))
            }
            {visibleTrees.length < total && (
                <div style={{ width: '100%', textAlign: 'center', marginTop: 40, marginBottom: 40 }}>
                    <Spin size="large" /> <span style={{ marginLeft: 10 }}>正在加载更多...</span>
                </div>
            )}
        </div>
    );
};

export { PlatformTreeView };

